if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();
        if (window.__ecwCartAddInFlight) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        window.__ecwCartAddInFlight = true;
        this.error = false;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        this.handleStandardSubmit(evt);
      }

      handleStandardSubmit(evt) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const addQty = typeof window.__ecwGetAddQty === 'function'
          ? window.__ecwGetAddQty(this.form)
          : (formData.get('quantity') || '1');
        formData.delete('quantity');
        formData.set('quantity', String(addQty));
        var addedHandle = (this.getAttribute('data-product-handle') || '').toLowerCase();
        if (!addedHandle) {
          var handleMatch = (window.location.pathname || '').match(/\/products\/([^/?#]+)/);
          if (handleMatch) addedHandle = decodeURIComponent(handleMatch[1]).toLowerCase();
        }
        var addedIsPad = addedHandle.indexOf('compresa') !== -1 || addedHandle.indexOf('protegeslip') !== -1;
        [
          'properties[_ecowoman_promo]',
          'properties[_ecowoman_free_qty]',
          'properties[_ecowoman_tier]',
          'properties[_ecowoman_paid_qty]',
          'properties[_bundle_gift_eligible]',
          'properties[_bundle_gift_color]',
          'properties[_bundle_gift_qty]'
        ].forEach(function (name) {
          if (!addedIsPad || name.indexOf('_ecowoman_') === 0) formData.delete(name);
        });
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            await this.showUpdatedCart(formData.get('id') || response.id, response.sections);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.finishSubmit(evt);
          });
      }

      async showUpdatedCart(variantId, sections) {
        if (typeof window.__ecwMarkCartAdd === 'function') {
          window.__ecwMarkCartAdd();
        }

        if (this.cart && sections && typeof this.cart.renderContents === 'function') {
          this.cart.renderContents({
            id: variantId,
            sections: sections,
            open: true,
          });
        } else if (typeof window.__ecwRefreshCartDrawer === 'function') {
          await window.__ecwRefreshCartDrawer({ open: true, sections: sections, minItemCount: 1 });
        } else if (this.cart && typeof this.cart.open === 'function') {
          this.cart.open();
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
        });

        await this.syncGiftBagAfterAdd();
      }

      async syncGiftBagAfterAdd() {
        try {
          if (typeof window.__ecwAddGiftBagAfterProduct === 'function') {
            await window.__ecwAddGiftBagAfterProduct(this.form);
          }
        } catch (err) {
          console.error(err);
        }
        try {
          if (typeof window.__ecwSyncGiftBagForCart === 'function') {
            await window.__ecwSyncGiftBagForCart();
          }
          if (typeof window.__ecwRefreshCartDrawer === 'function') {
            await window.__ecwRefreshCartDrawer();
          }
        } catch (err) {
          console.error(err);
        }
      }

      finishSubmit(evt) {
        window.__ecwCartAddInFlight = false;
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
        CartPerformance.measureFromEvent('add:user-action', evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
